var React = require('react');

function Home (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 36L48 8L84 36V80C84 82.1217 83.1571 84.1566 81.6569 85.6569C80.1566 87.1571 78.1217 88 76 88H20C17.8783 88 15.8434 87.1571 14.3431 85.6569C12.8429 84.1566 12 82.1217 12 80V36Z","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M36 88V48H60V88","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Home.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Home;

Home.default = Home;
